module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_budget-a61e4a2e79b7028115f5da996022b7d2.svg";